import { createContext } from "react";
import { BrandDetails } from "../../types/brand";

interface BrandContextType {
  brandDetails: BrandDetails | null;
  setBrandDetails: (details: BrandDetails | null) => void;
  isLoading: boolean;
  error: Error | null;
  fetchBrandDetails: () => Promise<void>;
  refetchBrandDetails: () => Promise<void>;
}

export const BrandContext = createContext<BrandContextType>({
  brandDetails: null,
  setBrandDetails: () => {},
  isLoading: false,
  error: null,
  fetchBrandDetails: async () => {},
  refetchBrandDetails: async () => {},
});
